// extracted by mini-css-extract-plugin
export default {"loginBlock":"LoginLayout_loginBlock__mFMNb","loginTitle":"LoginLayout_loginTitle__rVGs7","logo":"LoginLayout_logo__oMKxG"};